<template>
  <div class="step-progress-box">
    <p class="step-progress-title">
      {{ ruleInfo.ruleDesc }}
    </p>
    <div class="step-progress step-progress2">
      <span class="step-progress-text">完成进度 {{ completeSchedule }}%</span>
      <div
        class="step-progress-rate"
        :style="{ width: completeSchedule + '%' }"
      >
        <span class="step-progress-rate-text"
          >完成进度 {{ completeSchedule }}%</span
        >
      </div>
    </div>
    <div class="goLook" @click="goLook">去下单</div>
  </div>
</template>

<script>
export default {
  props: {
    ruleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    // 完成进度
    completeSchedule() {
      const schedule =
        Number(this.ruleInfo.curValue) / Number(this.ruleInfo.targetValue)
      return schedule > 1 ? 100 : parseInt(schedule * 100)
    }
  },
  methods: {
    goLook() {
      this.$autoRedirect(this.ruleInfo.app_url || this.ruleInfo.redirectUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-progress-box {
  position: relative;

  margin-top: 0.5rem;
  margin-left: -0.14rem;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0.26rem;
  }
  .step-progress-title {
    font-size: 0.24rem;
    line-height: 0.32rem;
    font-weight: 700;
    color: #333333;
  }
  .step-progress {
    position: relative;

    width: 100%;
    height: 0.24rem;
    margin-top: 0.24rem;
    overflow: hidden;

    background-color: #f0dfb8;
    border-radius: 0.12rem;

    text-align: right;
    box-shadow: 0px 2px 5px 0px rgba(191, 153, 115, 0.53) inset;
    &.step-progress2 {
      width: 3.98rem;
    }
    .step-progress-rate {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;

      width: 100%;
      height: 100%;
      overflow: hidden;

      background: linear-gradient(#ff753c, #ff3f3b);
      border-radius: 0.12rem;
      .step-progress-rate-text {
        position: absolute;
        left: 2.3rem /* 115/50 */;

        width: 100%;

        font-size: 0.2rem;
        line-height: 0.24rem;
        text-align: left;
        color: #ffffff;
      }
    }
    .step-progress-text {
      position: absolute;
      left: 2.3rem /* 115/50 */;
      z-index: 1;

      font-size: 0.2rem;
      line-height: 0.24rem;
      color: #a36733;
    }
  }
  .goLook {
    position: absolute;
    top: 0.14rem;
    right: -0.14rem;

    width: 1.44rem;
    height: 0.52rem;

    background: linear-gradient(#ff753c, #ff3f3b);
    border-radius: 0.26rem;

    font-size: 0.28rem;
    line-height: 0.52rem;
    text-align: center;
    color: #ffffff;
  }
}
</style>
